import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormData {
  [key: string]: any; // Generic object for form data
}

interface FactFindState {
  client1Details: FormData;
  client2Details: FormData;
  dependents: FormData;
  assetsProperty: FormData[]; // Now an array
  assetsNonProperty: FormData;
  assetsVehicles: FormData[]; // Now an array
  liabilities: FormData[]; // Now an array
  expenses: FormData;
}

const initialState: FactFindState = {
  client1Details: {},
  client2Details: {},
  dependents: {},
  assetsProperty: [], // Initialized as an empty array
  assetsNonProperty: {},
  assetsVehicles: [], // Initialized as an empty array
  liabilities: [], // Initialized as an empty array
  expenses: {},
};

const FactFindDataSlice = createSlice({
  name: "factFind",
  initialState,
  reducers: {
    updateFormData: (state : any, action: PayloadAction<{ formName: keyof FactFindState; formData: FormData }>) => {
      // If the formName is an array, push data instead of replacing
      if (Array.isArray(state[action.payload.formName])) {
        (state[action.payload.formName] as FormData[]).push(action.payload.formData);
      } else {
        state[action.payload.formName] = action.payload.formData;
      }
    },
    replaceFormData: (state, action: PayloadAction<{ formName: keyof FactFindState; formData: FormData[] }>) => {
      // This will replace the entire array instead of pushing
      if (Array.isArray(state[action.payload.formName])) {
        state[action.payload.formName] = action.payload.formData;
      }
    },
    resetFormData: () => initialState,
  },
});

export const { updateFormData, replaceFormData, resetFormData } = FactFindDataSlice.actions;
export default FactFindDataSlice.reducer;
